<template>
  <div class="jsbridge">
    <ul>
      <li>
        <button @click="getToken">Get FCM token</button>
      </li>
      <li>
        <button @click="openWeb">Open Webview</button>
      </li>
      <li>
        <button @click="openBrowser">Open Browser</button>
      </li>
      <li>
        <button @click="setBadge">Set Badge</button>
      </li>
      <li>
        <button @click="getPKGInfo">Set PKGInfo of App</button>
      </li>
    </ul>
  </div>
</template>

<script>
import JSbridge from "../Services/JSbridge";

export default {
  name: "JSbridge",

  data() {
    return {
      vConsole: null
    }
  },

  methods: {
    getToken() {
      return JSbridge.getFCMToken(1000)
          .then((data) => {
            alert(JSON.stringify(data, null, 4));
          })
          .catch((error) => {
            error && console.error(error);
          });
    },
    openWeb() {
      const url = prompt('请输入URL', 'https://www.baidu.com');
      return JSbridge.webOpen(url);
    },
    openBrowser() {
      const url = prompt('请输入URL', 'https://www.baidu.com');
      return JSbridge.browserOpen(url);
    },
    setBadge() {
      const badge = prompt('请设置 Badge 值', '10');
      if (badge) {
        return JSbridge.setBadge(badge);
      }
    },
    getPKGInfo() {
      return JSbridge.getPKGInfo()
          .then((data) => {
            alert(JSON.stringify(data, null, '    '));
          });
    },
  },

  mounted() {
    if (!this.vConsole) {
      import(
          /* webpackChunkName: "vconsole" */
          /* webpackMode: "lazy" */
          "vconsole")
          .then((module) => {
            const VConsole = module.default || module;
            this.vConsole = new VConsole();
          })
    }

  }
}
</script>

<style lang="scss">
.jsbridge {
  width: 100%;
  height: 100vh;
  position: relative;
  background: #ffffff;

  ul {
    width: 80%;
    padding: 0;
    margin: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    li {
      width: 100%;
      padding: 0;
      list-style: none;
      margin: 1em auto;
    }
  }

  button {
    width: 100%;
    border: 0;
    padding: 0.5em 2em;
    background: #000000;
    color: #ffffff;
    border-radius: 5px;
  }

}
</style>
